import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useAccount } from 'dashboard/composables/useAccount';
import suiteAPI from 'dashboard/api/integrations/suite';

export function useSuiteClickToCall() {
  const { t } = useI18n();
  const { accountId } = useAccount();
  const currentUser = useMapGetter('getCurrentUser');
  const isDialing = ref(false);

  const hasSuiteExtension = computed(() => {
    const softphone = currentUser.value?.custom_attributes?.suite_softphone;
    if (!softphone || typeof softphone !== 'object') return false;
    return Number(softphone.account_id) === Number(accountId.value);
  });

  const canCall = phoneNumber =>
    hasSuiteExtension.value && Boolean(phoneNumber?.toString().trim());

  const dial = async phoneNumber => {
    if (!canCall(phoneNumber) || isDialing.value) return;

    isDialing.value = true;
    try {
      const { data } = await suiteAPI.clickToCall({ phoneNumber });
      useAlert(
        data?.message || t('INTEGRATION_APPS.SUITE.CLICK_TO_CALL.SUCCESS')
      );
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        t('INTEGRATION_APPS.SUITE.CLICK_TO_CALL.ERROR');
      useAlert(message);
    } finally {
      isDialing.value = false;
    }
  };

  return {
    hasSuiteExtension,
    canCall,
    isDialing,
    dial,
  };
}
